<template>
  <question-base-wrapper
    v-bind="baseWrapperProps"
    class="base-date-wrapper"
  >
    <time-zone-warning
      v-if="isWarningTextShown"
      :question-date="questionData[questionFields.field]"
    />
    <validation-provider
      :data-unit-test="`${stepId}_${questionId}`"
      :vid="validationId"
      :name="questionId"
      :rules="dateValidationRules"
    >
      <component
        :is="`qz-date-${componentType}`"
        v-model="questionData[questionFields.field]"
        :form-observer="formObserver"
        :data-test="snakeCase(questionFields.field)"
        :vid="validationId"
        :is-day-shown="isDayShown"
        :year-options="getYearsOptions"
        :validation-errors="validationErrors"
        :date-rule="dateValidationRules"
      />
    </validation-provider>
  </question-base-wrapper>
</template>

<script>
import { computed } from '@vue/composition-api';
import QuestionBase from './Base';
import QuestionBaseWrapper from './BaseWrapper';
import { getRangeOfYears, UtcDate } from '@/helpers/date';
import TimeZoneWarning from '@/components/TimeZoneWarning/TimeZoneWarning.vue';
import useTimeZoneWarning from '@/composables/useTimeZoneWarning.js';

export default {
  name: 'question-base-date',
  extends: QuestionBase,
  components: {
    QuestionBaseWrapper,
    TimeZoneWarning,
  },
  props: {
    maxYears: {
      type: Number,
      default: 5,
    },
    minYears: {
      type: Number,
      default: 0,
    },
    isVerticalSplitted: {
      type: Boolean,
      default: false,
    },
    vid: {
      type: String,
      default: null,
    },
    isDayShown: {
      type: Boolean,
      default: true,
    },
    componentType: {
      type: String,
      default: 'select',
    },
  },
  data () {
    return { fields: ['field'] };
  },
  computed: {
    getYearsOptions () {
      return getRangeOfYears(this.maxYears - this.minYears, new UtcDate().getFullYear() - this.minYears);
    },
    dateValidationRules () {
      return this.validationRules ? this.validationRules.field : 'required';
    },
    additionalClasses () {
      return {
        vertically: this.isVerticalSplitted,
      };
    },
    validationId () {
      return this.vid || `${this.stepId}_${this.questionId}`;
    },
  },
  setup (props) {
    const isWarningTextShown = computed((componentContext) => {
      return useTimeZoneWarning(
        props.formObserver,
        `${props.stepId}_${props.questionId}`,
        componentContext.dateValidationRules,
      );
    });

    return {
      getRangeOfYears,
      isWarningTextShown,
    };
  },
};
</script>

<style lang="scss" scoped src="@/assets/scss/shared/vertical-row.scss"/>
